import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { UserSignUpFormValues } from '../../events/EventSignUp';

type SignUpFormState = {
  valuesByEventId: Record<string, Partial<UserSignUpFormValues>>;
  otpStartedAtByEventId: Record<string, number>;
  isSignUpByEventId: Record<string, boolean>;
  setValues: (eventId: string, values: Partial<UserSignUpFormValues>) => void;
  setOtpStartedAt: (eventId: string, startedAt: number) => void;
  setIsSignUp: (eventId: string, isSignUp: boolean) => void;
  clearValues: (eventId: string) => void;
};

export const useSignUpFormStore = create<SignUpFormState>()(
  persist(
    (set) => ({
      valuesByEventId: {},
      otpStartedAtByEventId: {},
      isSignUpByEventId: {},
      setValues: (eventId, values) =>
        set((state) => ({
          valuesByEventId: {
            ...state.valuesByEventId,
            [eventId]: { ...state.valuesByEventId[eventId], ...values },
          },
        })),
      setOtpStartedAt: (eventId, startedAt) =>
        set((state) => ({
          otpStartedAtByEventId: {
            ...state.otpStartedAtByEventId,
            [eventId]: startedAt,
          },
        })),
      setIsSignUp: (eventId, isSignUp) =>
        set((state) => ({
          isSignUpByEventId: {
            ...state.isSignUpByEventId,
            [eventId]: isSignUp,
          },
        })),
      clearValues: (eventId) =>
        set((state) => {
          const nextValues = { ...state.valuesByEventId };
          const nextOtp = { ...state.otpStartedAtByEventId };
          const nextIsSignUp = { ...state.isSignUpByEventId };
          delete nextValues[eventId];
          delete nextOtp[eventId];
          delete nextIsSignUp[eventId];
          return { valuesByEventId: nextValues, otpStartedAtByEventId: nextOtp, isSignUpByEventId: nextIsSignUp };
        }),
    }),
    {
      name: 'event-signup-form',
    },
  ),
);
